import { inject } from '@angular/core';
import { Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoginService } from "../../login/login.service";

export const checkLoginState = (snapshot: RouterStateSnapshot): Observable<boolean | UrlTree> => {
  const loginService = inject(LoginService);
  const router = inject(Router);

  return loginService.user$.pipe(
    map(user => user ? true : router.createUrlTree(['/login']))
  );
};
